<template>
    <div class="stational_operations x_scrollable">
        <h1 class="ui header">
            <!-- 待處理訂單 -->
            {{ $t('ui.pages.monitor.title.pending_operations') }}
            <div class="sub header"
                v-html="$t('ui.pages.monitor.sub_title.assigned_to_stationg_but_not_completed_operations', {
                    station_name: current_station.name
                })"
            >
                <!--
                    分配給
                    <span style="color: green;">{{ current_station.name }}</span>
                    處理但未完成的訂單
                -->
            </div>

        </h1>
        <table class="ui compact celled table">
            <thead class="center aligned">
                <tr>
                    <!--
                        <th>日期</th>
                        <th>訂單號</th>
                        <th>客戶</th>
                        <th>客戶備註</th>
                        <th>您的備註</th>
                        <th>單數</th>
                        <th>託運文件</th>
                    -->
                    <th>{{ $t('ui.general.date') }}</th>
                    <th>{{ $t('models.attributes.operations.number') }}</th>
                    <th>{{ $t('models.attributes.operations.customer') }}</th>
                    <th>{{ $t('models.attributes.operations.customer_note') }}</th>
                    <th>{{ $t('models.attributes.operations.your_note') }}</th>
                    <th>{{ $t('ui.pages.operations.waybill_amount') }}</th>
                    <th>{{ $t('models.attributes.operations.file') }}</th>

                    <th class="center aligned">
                        <div class="ui basic icon button" @click="show_filter = !show_filter">
                            <i class="angle double up icon" v-if="show_filter"></i>
                            <i class="angle double down icon" v-else></i>
                        </div>
                    </th>
                </tr>
                <tr class="center aligned" v-show="show_filter">
                    <th>
                        <table>
                            <tbody>
                                <tr>
                                    <td>從</td>
                                    <td>
                                        <div class="ui mini input">
                                            <input type="datetime-local" v-model="search_params.begin_at">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>到</td>
                                    <td>
                                        <div class="ui mini input">
                                            <input type="datetime-local" v-model="search_params.end_at">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.number" @keyup.enter="fetch_operations">
                        </div>
                    </th>
                    <th>
                        <select class="ui dropdown" v-dropdown v-model="search_params.customer_identity">
                            <option value="">{{ $t('ui.general.please_select') }}</option>
                            <option value="'null'">無客戶</option>
                            <option v-for="customer in $store.state.provider.customers" :value="customer.identity">{{ customer.company_name }}</option>
                        </select>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.customer_note" @keyup.enter="fetch_operations">
                        </div>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.provider_note" @keyup.enter="fetch_operations">
                        </div>
                    </th>
                    <th></th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.original_file_name" @keyup.enter="fetch_operations">
                        </div>
                    </th>
                    <th>
                        <div class="ui icon mini buttons">
                            <div class="ui black basic button" @click.prevent="fetch_operations">
                                <i class="search icon"></i>
                            </div>
                            <div class="ui black basic button" @click.prevent="init_search_params">
                                <i class="refresh icon"></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="show_operations">
                <Operation
                    v-for="operation in operations"
                    :key="operation.identity"
                    :operation="operation"
                    :is_processing="is_processing"
                ></Operation>
                <tr v-if="operations.length <= 0" class="center aligned">
                    <td colspan="8" >
                        <h5>{{ $t('ui.general.no_data') }}</h5>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="loading">
                    <td colspan="8">
                        <div class="ui active centered inline loader"></div>
                    </td>
                </tr>
            </tbody>
        </table>

        <Paginator
            v-if="operations.length > 0"
            :total_pages="pagination.total_pages"
            :current_page="pagination.current_page"
            change_page_channel="personal_operations"
        />
    </div>
</template>

<script>
import Operation from "./item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'

export default {
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            show_operations: false,
            show_filter: false,
            operations: [],
            pagination: {},
            search_params: {
                begin_at: null,
                end_at: null,
                number: null,
                provider_note: null,
                customer_identity: null,
                customer_note: null,
                original_file_name: null,
                station_identity: null,
                is_done: false,
                is_canceled: false,
            },
            errors: [],
        }
    },
    computed: {
        current_station() {
            return this.$store.state.provider.current_staff.station
        },
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.search_params.station_identity = this.current_station.identity
                resolve()
            })
            await this.fetch_operations()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })

            // pagination channel
            this.$bus.$off('personal_operations')
            this.$bus.$on('personal_operations', (page) => {
                this.$store.state.provider.operations_module.current_page = page
                this.search_params.page = page
                this.fetch_operations()
            })
        },
        fetch_operations() {
            if (this.is_processing == false) {
                this.show_operations = false
                this.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operations).parse(
                    {},
                    "?" + object_to_query(this.search_params)
                )
                return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.operations = response.data.operations
                        this.pagination = response.data.pagination
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取訂單失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取訂單失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                    this.errors.push(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.operations'),
                            reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_processing = false
                        this.show_operations = true
                    }, 300)
                })
            }
        },
        init_search_params() {
            this.search_params = {
                begin_at: null,
                end_at: null,
                number: null,
                provider_note: null,
                customer_identity: null,
                customer_note: null,
                original_file_name: null,
                station_identity: this.current_station.identity,
                is_done: false,
                is_canceled: false,
            }
            $(".stational_operations .ui.dropdown").dropdown('clear')
        },
    },
    components: {
        Operation,
        Paginator,
    }
}
</script>
<style scoped>
</style>
